import React, { useState } from "react";
import CountryDropdown from "components/dropdowns/reactselect/CountryDropdown";
import StateDropdown from "components/dropdowns/reactselect/StateDropdown";

interface Props {
  value: string
  onChange: (value: string) => void
}

const CountryStateInput = (props: Props) => {
  const [countryId, stateId] = props.value.split("_");
  const [country, setCountry] = useState(() => serverReference.countries.find(c => c.key === countryId));
  const [selectedState, setSelectedState] = useState(() => country?.states.find(s => s.key.toString() === stateId));

  const onCountryChanged = (newCountry: server.dto.Country) => {
    const defaultState = newCountry.states.find(s => s.isCountryDefault);

    setCountry(newCountry);
    setSelectedState(defaultState);
    props.onChange(`${newCountry.key}_${defaultState.key}`);
  };

  const onStateChanged = (newState: server.dto.State) => {
    setSelectedState(newState);
    props.onChange(`${country.key}_${newState.key}`);
  };

  return <div className="flex-column gap-small">
    <CountryDropdown
      value={country}
      onChange={onCountryChanged}
    />
    <StateDropdown
      value={selectedState}
      options={country?.states ?? []}
      onChange={onStateChanged}
    />
  </div>;
};

export default CountryStateInput;
